import React, { useState, useEffect, useMemo } from 'react'
import IPButton from '../../../../../components/IPButton'
import Translations from '../../../../../translations'
import { translate } from '../../../../../base/localization'

import IPSelectBox from '../../../../../components/IPSelectBox'
import { IBrand, ICategoryList, ICompany } from '../../../components/models/models'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import { useCustomReducer } from '../../../../../base/customHooks'
import { getBrandApi, getCategoryList, getCompanyApi } from '../../../components/api'
import Table from '../../../../../components/Table'
import {
  ICampaignAnalysisRow,
  ICampaignReportRequest,
  ICampaignReportResponse,
} from '../models/models'
import { exportToXLSX, exportToXLSXVDFMultipleColumns, getDateByTimezoneOffset } from '../../../../../base/utils/dataHelper'
import Swal from 'sweetalert2'
import { CampaignReportApi } from '../services/campaignReportApi'
import InputCampaign from '../../../../../components/InputCampaign'
import IPInput from '../../../../../components/IPInput'
import { GetQuotaListApi } from '../../../ProductOperation/GeneralProductStats/services/getQuotaListApi'
import { QuotaListReturnModel } from '../../../ProductOperation/GeneralProductStats/models/models'
import { CampaignBundleService } from '../../../ProductOperation/CampaignBundleCrud/services/CampaignBundleService'
import * as XLSX from 'xlsx'

interface ICampaignReportPageState {
  companiesOption?: ISelectOption
  reportData?: ICampaignReportResponse
  dealerCode?: string
  productCode?: string
  brand?: ISelectOption
  categoryCode?: ISelectOption
  quota?: ISelectOption
  selectedCampaign?: ISelectOption
  brandList?: IBrand[]
  KotaList?: ISelectOption[]
  categoryList?: ISelectOption[]
  campaignList?: any[]
}

function CampaignReport(props: BaseComponentWithContextProps) {
  const [companies, setCompanies] = useState<ICompany[]>([])

  const getInitialState = (): ICampaignReportPageState => {
    return {
      reportData: {
        Rows: [],
        Summary: undefined,
        ByCompany: [],
        ByCampaign: [],
        ByDealer: [],
        ByProduct: [],
        ByBrand: [],
        ByCategory: [],
        ByQuota: [],
      },
    }
  }

  const inititalStartDate = new Date()
  inititalStartDate.setDate(1)
  inititalStartDate.setHours(0)
  inititalStartDate.setMinutes(0)
  inititalStartDate.setSeconds(0)
  const [startDate, setStartDate] = useState(inititalStartDate)
  const [endDate, setEndDate] = useState(new Date())

  const getDate = async (data: any, title: string) => {
    if (title === 'Start') setStartDate(data)
    else setEndDate(data)
  }

  const toDateTimeLocal = date => {
    if (date != null) {
      return date
        .toLocaleString('sv-SE', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
        .replace(' ', 'T')
    }
    return undefined
  }


  const [state, setState] = useCustomReducer<ICampaignReportPageState>(getInitialState())
  const t = translate(Translations)

  const getCompanies = async () => {
    const company: any[] = await getCompanyApi()
    const data: ICompany[] = []
    company
      .filter(com => com.Name !== 'Index Group')
      .forEach(co => data.push(co))
    setCompanies(data)
  }

  const getCategory = async () => {
    const data: ICategoryList[] = await getCategoryList()
    const categoryList: ISelectOption[] = []
    if (data) {
      data.forEach(dt => categoryList.push({ value: dt.SapCode, label: `${dt.Name} (${dt.SapCode})` }))
    }
    setState({ categoryList })
  }

  const getQuota = async () => {
    const api = new GetQuotaListApi({})
    const data = await api.getQuotaList()
    const quotaList: ISelectOption[] = []
    if (data) {
      data.forEach((dt: QuotaListReturnModel) =>
        quotaList.push({ value: dt.ZZKTN, label: `${dt.ZZKTN}` })
      )
    }
    setState({ KotaList: quotaList.length > 0 ? quotaList : undefined })
  }

  const getBrand = async () => {
    const data: any[] = await getBrandApi()
    setState({ brandList: data })
  }

  const getCampaign = async () => {
    const api = new CampaignBundleService({})
    const data: any[] = await api.getCampaignIdList()
    setState({ campaignList: data })
  }

  useEffect(() => {
    getCompanies()
    getBrand()
    getQuota()
    getCategory()
    getCampaign()
  }, [])

  const getReport = () => {
    props.showLoading()

    const campaignApi: CampaignReportApi = new CampaignReportApi({})

    const req: ICampaignReportRequest = {
      StartDate: startDate ? getDateByTimezoneOffset(startDate) : undefined,
      EndDate: endDate ? getDateByTimezoneOffset(endDate) : undefined,
      CampaignId: state.selectedCampaign ? Number(state.selectedCampaign.value) : undefined,
      DealerCode: state.dealerCode,
      ProductCode: state.productCode,
      Company: state.companiesOption ? Number(state.companiesOption.value) : undefined,
      Brand: state.brand?.value?.toString(),
      CategoryCode: state.categoryCode?.value?.toString(),
      Quota: state.quota?.value?.toString(),
    }

    try {
      campaignApi
        .campaignReport(req)
        .then((res: ICampaignReportResponse) => {
          if (res) {
            setState({ reportData: res })
          } else {
            setState({
              reportData: {
                Rows: [],
                Summary: undefined,
                ByCompany: [],
                ByCampaign: [],
                ByDealer: [],
                ByProduct: [],
                ByBrand: [],
                ByCategory: [],
                ByQuota: [],
              },
            })
          }
          props.hideLoading()
        })
        .catch(err => {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: err?.description || 'Kampanya raporu alınırken bir hata oluştu.',
          })
        })
    } catch (err: any) {
      props.hideLoading()
      Swal.fire({
        icon: 'error',
        title: err?.description || 'Kampanya raporu alınırken bir hata oluştu.',
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }
  }

  const formatNumber = (value?: number | null) => {
    return Number(value || 0).toLocaleString('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }

  const formatDate = (value: string | Date) => {
    if (!value) return ''
    const d = new Date(value)
    return d.toLocaleDateString('tr-TR')
  }

  const rawTableColumns = useMemo(
    () => [
      { Header: 'Kampanya', accessor: 'campaignID' },
      { Header: 'Şirket', accessor: 'companyName' },
      { Header: 'Bayi Kodu', accessor: 'dealerCode' },
      { Header: 'Bayi Ünvan', accessor: 'dealerName' },
      { Header: 'Ürün Kodu', accessor: 'productCode' },
      { Header: 'Ürün Adı', accessor: 'productName' },
      { Header: 'Marka', accessor: 'brand' },
      { Header: 'Kategori', accessor: 'category' },
      { Header: 'Kota', accessor: 'quota' },
      { Header: 'Adet', accessor: 'quantity' },
      { Header: 'Kampanyalı Tutar', accessor: 'campaignPrice' },
      { Header: 'Eski Tutar', accessor: 'oldPrice' },
      { Header: 'İndirim Tutarı', accessor: 'discountAmount' },
      { Header: 'Tarih', accessor: 'createdTime' },
    ],
    []
  )

  const analysisTableColumns = useMemo(
    () => [
      { Header: 'Kod', accessor: 'groupKey' },
      { Header: 'Ad', accessor: 'groupName' },
      { Header: 'Kayıt Sayısı', accessor: 'recordCount' },
      { Header: 'Toplam Adet', accessor: 'totalQuantity' },
      { Header: 'Kampanyalı Tutar', accessor: 'totalCampaignAmount' },
      { Header: 'Eski Tutar', accessor: 'totalOldAmount' },
      { Header: 'İndirim Tutarı', accessor: 'totalDiscountAmount' },
      { Header: 'Ort. İndirim', accessor: 'avgDiscountAmount' },
      { Header: 'Ort. İndirim %', accessor: 'avgDiscountRate' },
      { Header: 'Adet Payı %', accessor: 'quantityShareRate' },
      { Header: 'Ciro Payı %', accessor: 'campaignAmountShareRate' },
      { Header: 'Farklı Ürün', accessor: 'distinctProductCount' },
      { Header: 'Farklı Bayi', accessor: 'distinctDealerCount' },
      { Header: 'Farklı Şirket', accessor: 'distinctCompanyCount' },
      { Header: 'Farklı Kampanya', accessor: 'distinctCampaignCount' },
    ],
    []
  )

  const rawTableData = useMemo(() => {
    return (state.reportData?.Rows || []).map(item => ({
      campaignID: item.CampaignID + ' - ' + state.campaignList?.find(c => c.Id === item.CampaignID)?.Name || '',
      companyName: item.CompanyName,
      dealerCode: item.DealerCode?.replace('0000', ''),
      dealerName: item.DealerName,
      productCode: item.ProductCode,
      productName: item.ProductName,
      brand: item.Brand,
      category: state.categoryList?.find(c => c.value === item.Category)?.label || item.Category,
      quota: item.Quota,
      quantity: item.ProductQuantity,
      campaignPrice: formatNumber(item.CampaignPrice),
      oldPrice: formatNumber(item.OldPrice),
      discountAmount: formatNumber(item.PriceDiffForUnit),
      createdTime: formatDate(item.CreatedTime),
    }))
  }, [state.reportData?.Rows])

  const mapAnalysisTableData = (items: ICampaignAnalysisRow[], type?: string) => {
    return items.map(item => ({
      groupKey: item.GroupKey,
      groupName: type === "Category" ? state.categoryList?.find(c => c.value === item.GroupName)?.label :
        type === "Quota" ? state.KotaList?.find(q => q.value === item.GroupName)?.label :
          type === "Campaign" ? state.campaignList?.find(c => c.Id === Number(item.GroupKey))?.Name :
            item.GroupName,

      recordCount: item.RecordCount,
      totalQuantity: item.TotalQuantity,
      totalCampaignAmount: formatNumber(item.TotalCampaignAmount),
      totalOldAmount: formatNumber(item.TotalOldAmount),
      totalDiscountAmount: formatNumber(item.TotalDiscountAmount),
      avgDiscountAmount: formatNumber(item.AvgDiscountAmount),
      avgDiscountRate: formatNumber(item.AvgDiscountRate),
      quantityShareRate: formatNumber(item.QuantityShareRate),
      campaignAmountShareRate: formatNumber(item.CampaignAmountShareRate),
      distinctProductCount: item.DistinctProductCount,
      distinctDealerCount: item.DistinctDealerCount,
      distinctCompanyCount: item.DistinctCompanyCount,
      distinctCampaignCount: item.DistinctCampaignCount,
    }))
  }

  const byCompanyTableData = useMemo(
    () => mapAnalysisTableData(state.reportData?.ByCompany || []),
    [state.reportData?.ByCompany]
  )

  const byCampaignTableData = useMemo(
    () => mapAnalysisTableData(state.reportData?.ByCampaign || [], "Campaign"),
    [state.reportData?.ByCampaign]
  )

  const byDealerTableData = useMemo(
    () => mapAnalysisTableData(state.reportData?.ByDealer || []),
    [state.reportData?.ByDealer]
  )

  const byProductTableData = useMemo(
    () => mapAnalysisTableData(state.reportData?.ByProduct || []),
    [state.reportData?.ByProduct]
  )

  const byBrandTableData = useMemo(
    () => mapAnalysisTableData(state.reportData?.ByBrand || []),
    [state.reportData?.ByBrand]
  )

  const byCategoryTableData = useMemo(
    () => mapAnalysisTableData(state.reportData?.ByCategory || [], "Category"),
    [state.reportData?.ByCategory]
  )

  const byQuotaTableData = useMemo(
    () => mapAnalysisTableData(state.reportData?.ByQuota || [], "Quota"),
    [state.reportData?.ByQuota]
  )

  const setNumberFormatByHeader = (ws: XLSX.WorkSheet, headers: string[], format: string) => {
    if (!ws['!ref']) return

    const range = XLSX.utils.decode_range(ws['!ref'])
    const headerRow = range.s.r

    const headerMap = new Map<string, number>()

    for (let c = range.s.c; c <= range.e.c; c++) {
      const addr = XLSX.utils.encode_cell({ r: headerRow, c })
      const cell = ws[addr]
      const text = cell?.v?.toString()?.trim()
      if (text) headerMap.set(text, c)
    }

    headers.forEach(h => {
      const col = headerMap.get(h)
      if (col === undefined) return

      for (let r = headerRow + 1; r <= range.e.r; r++) {
        const addr = XLSX.utils.encode_cell({ r, c: col })
        const cell = ws[addr]
        if (!cell) continue
        if (cell.t === 'n') (cell as any).z = format
      }
    })
  }

  const autoFitCols = (ws: XLSX.WorkSheet, rows: any[], maxWch = 50) => {
    if (!rows || rows.length === 0) return

    const headers = Object.keys(rows[0] ?? {})
    const widths = headers.map(h => {
      let maxLen = String(h ?? '').length + 2

      for (let i = 0; i < Math.min(rows.length, 300); i++) {
        const v = rows[i]?.[h]
        const s = v == null ? '' : String(v)
        if (s.length + 2 > maxLen) maxLen = s.length + 2
      }

      return Math.min(maxWch, Math.max(10, maxLen))
    })

      ; (ws as any)['!cols'] = widths.map(w => ({ wch: w }))
  }

  const excelButton = async () => {
    try {
      const report = state.reportData

      if (!report) {
        Swal.fire({
          icon: 'warning',
          title: 'Excel için veri bulunamadı.',
        })
        return
      }

      const wb = XLSX.utils.book_new()

      const rowsSheet = (report.Rows || []).map(item => ({
        KampanyaID: item.CampaignID,
        KampanyaAdı: state.campaignList?.find(c => c.Id === item.CampaignID)?.Name || '',
        ŞirketKodu: item.CompanyCode,
        ŞirketAdı: item.CompanyName,
        BayiKodu: item.DealerCode?.replace('0000', ''),
        BayiÜnvan: item.DealerName,
        ÜrünKodu: item.ProductCode,
        ÜrünAdı: item.ProductName,
        Marka: item.Brand,
        Kategori: state.categoryList?.find(c => c.value === item.Category)?.label || item.Category,
        Kota: state.KotaList?.find(q => q.value === item.Quota)?.label || item.Quota,
        Adet: item.ProductQuantity,
        KampanyalıTutar: Number(item.CampaignPrice || 0),
        EskiTutar: Number(item.OldPrice || 0),
        İndirimTutarı: Number(item.PriceDiffForUnit || 0),
        ParaBirimi: item.CurrentCurrency,
        Tarih: formatDate(item.CreatedTime),
      }))

      const summarySheet = report.Summary
        ? [
          {
            KayıtSayısı: report.Summary.RecordCount,
            ToplamAdet: report.Summary.TotalQuantity,
            KampanyalıTutar: Number(report.Summary.TotalCampaignAmount || 0),
            EskiTutar: Number(report.Summary.TotalOldAmount || 0),
            ToplamİndirimTutarı: Number(report.Summary.TotalDiscountAmount || 0),
            KampanyalıTutarLocal: Number(report.Summary.TotalCampaignAmountLocal || 0),
            EskiTutarLocal: Number(report.Summary.TotalOldAmountLocal || 0),
            OrtalamaİndirimTutarı: Number(report.Summary.AvgDiscountAmount || 0),
            OrtalamaİndirimOranı: Number(report.Summary.AvgDiscountRate || 0),
            AdetBaşınaOrtalamaİndirim: Number(report.Summary.AvgDiscountPerQuantity || 0),
            FarklıÜrünSayısı: report.Summary.DistinctProductCount,
            FarklıBayiSayısı: report.Summary.DistinctDealerCount,
            FarklıŞirketSayısı: report.Summary.DistinctCompanyCount,
            FarklıKampanyaSayısı: report.Summary.DistinctCampaignCount,
          },
        ]
        : []

      const mapAnalysisExcelData = (items: ICampaignAnalysisRow[], type?: string) => {
        return (items || []).map(item => ({
          Kod: item.GroupKey,
          Ad:
            type === 'Category'
              ? state.categoryList?.find(c => c.value === item.GroupName)?.label || item.GroupName
              : type === 'Quota'
                ? state.KotaList?.find(q => q.value === item.GroupName)?.label || item.GroupName
                : type === 'Campaign'
                  ? state.campaignList?.find(c => c.Id === Number(item.GroupKey))?.Name || item.GroupName
                  : item.GroupName,
          KayıtSayısı: item.RecordCount,
          ToplamAdet: item.TotalQuantity,
          KampanyalıTutar: Number(item.TotalCampaignAmount || 0),
          EskiTutar: Number(item.TotalOldAmount || 0),
          İndirimTutarı: Number(item.TotalDiscountAmount || 0),
          OrtalamaİndirimTutarı: Number(item.AvgDiscountAmount || 0),
          OrtalamaİndirimOranı: Number(item.AvgDiscountRate || 0),
          AdetPayıOranı: Number(item.QuantityShareRate || 0),
          CiroPayıOranı: Number(item.CampaignAmountShareRate || 0),
          FarklıÜrünSayısı: item.DistinctProductCount,
          FarklıBayiSayısı: item.DistinctDealerCount,
          FarklıŞirketSayısı: item.DistinctCompanyCount,
          FarklıKampanyaSayısı: item.DistinctCampaignCount,
        }))
      }

      const byCompanySheet = mapAnalysisExcelData(report.ByCompany || [])
      const byCampaignSheet = mapAnalysisExcelData(report.ByCampaign || [], 'Campaign')
      const byDealerSheet = mapAnalysisExcelData(report.ByDealer || [])
      const byProductSheet = mapAnalysisExcelData(report.ByProduct || [])
      const byBrandSheet = mapAnalysisExcelData(report.ByBrand || [])
      const byCategorySheet = mapAnalysisExcelData(report.ByCategory || [], 'Category')
      const byQuotaSheet = mapAnalysisExcelData(report.ByQuota || [], 'Quota')

      const appendSheet = (sheetName: string, data: any[]) => {
        const ws = XLSX.utils.json_to_sheet(data.length > 0 ? data : [{}])
        XLSX.utils.book_append_sheet(wb, ws, sheetName)

        setNumberFormatByHeader(
          ws,
          [
            'KampanyalıTutar',
            'EskiTutar',
            'İndirimTutarı',
            'KampanyalıTutarLocal',
            'EskiTutarLocal',
            'OrtalamaİndirimTutarı',
            'OrtalamaİndirimOranı',
            'AdetBaşınaOrtalamaİndirim',
            'AdetPayıOranı',
            'CiroPayıOranı',
          ],
          '#,##0.00'
        )

        autoFitCols(ws, data.length > 0 ? data : [{}])
      }

      appendSheet('Ham Data', rowsSheet)
      appendSheet('Özet', summarySheet)
      appendSheet('Şirket Bazlı Analiz', byCompanySheet)
      appendSheet('Kampanya Bazlı Analiz', byCampaignSheet)
      appendSheet('Bayi Bazlı Analiz', byDealerSheet)
      appendSheet('Ürün Bazlı Analiz', byProductSheet)
      appendSheet('Marka Bazlı Analiz', byBrandSheet)
      appendSheet('Kategori Bazlı Analiz', byCategorySheet)
      appendSheet('Kota Bazlı Analiz', byQuotaSheet)

      XLSX.writeFile(wb, `KampanyaKullanimRaporu_${toDateTimeLocal(new Date())}.xlsx`)
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err?.description || err?.message || 'Excel oluşturulurken hata oluştu.',
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  const summary = state.reportData?.Summary

  return (
    <div className='content col-lg-12 m-auto'>
      <div className='card'>
        <div className='card-header d-flex justify-content-between align-items-center'>
          <span className='h4 mb-0'>Kampanya Kullanım Raporu</span>
          <div className='d-flex align-items-center'>
            <span>Excel: </span>
            <button
              type='button'
              style={{
                border: '1px solid #2e7d32',
                borderRadius: 0,
                width: '29px',
                height: '29px',
                backgroundColor: 'white',
                margin: '0 10px',
              }}
              onClick={excelButton}
              className='btn text-capitalize background-white-important d-flex align-items-center'
            >
              <i
                className='fas fa-file-excel'
                style={{
                  marginLeft: '-6px',
                  fontSize: '18px',
                  color: '#2e7d32',
                }}
              ></i>
            </button>
          </div>
        </div>

        <div className='card-body'>
          <form className='formbanner'>
            <div className='row mb-3'>
              <div className='form-group col-md-1'></div>

              <div className='col-12 col-md-2 mb-3'>
                <InputCampaign
                  type='date'
                  id='StartDate'
                  name='StartDate'
                  label={'Başlangıç Tarihi'}
                  value={toDateTimeLocal(startDate)}
                  onChange={e => getDate(e.target.value, 'Start')}
                  isActive
                />
              </div>

              <div className='col-12 col-md-2 mb-3'>
                <InputCampaign
                  type='date'
                  id='EndDate'
                  name='EndDate'
                  label={'Bitiş Tarihi'}
                  value={toDateTimeLocal(endDate)}
                  onChange={e => getDate(e.target.value, 'End')}
                  isActive
                />
              </div>

              <div className='col-12 col-md-2 mb-3'>
                <IPSelectBox
                  isClearable
                  options={
                    companies &&
                    companies.map((item: ICompany) => ({
                      label: item.Name,
                      value: `${item.Id}`,
                    }))
                  }
                  placeholder='Şirket Seçiniz...'
                  value={state.companiesOption}
                  onChangeSingle={option => setState({ companiesOption: option })}
                />
              </div>

              <div className='col-12 col-md-2 mb-3'>
                <IPInput
                  type='text'
                  id='DealerCode'
                  name='DealerCode'
                  placeholder={'Bayi Kodu'}
                  value={state.dealerCode}
                  onChange={e => setState({ dealerCode: e.target.value })}
                />
              </div>

              <div className='col-12 col-md-2 mb-3'>
                <IPInput
                  type='text'
                  id='ProductCode'
                  name='ProductCode'
                  placeholder={'Ürün Kodu'}
                  value={state.productCode}
                  onChange={e => setState({ productCode: e.target.value })}
                />
              </div>

              <div className='form-group col-md-1'></div>
              <div className='form-group col-md-1'></div>

              <div className='form-group col-md-2'>
                <IPSelectBox
                  placeholder='Grup Kodu'
                  value={state.categoryCode}
                  options={state.categoryList}
                  isClearable
                  onChangeSingle={options => setState({ categoryCode: options })}
                />
              </div>

              <div className='form-group col-md-2'>
                <IPSelectBox
                  isClearable
                  id='Kota'
                  name='Kota'
                  placeholder='Kota seçiniz...'
                  options={state.KotaList}
                  value={state.quota}
                  onChangeSingle={option => setState({ quota: option })}
                />
              </div>

              <div className='form-group col-md-2'>
                <IPSelectBox
                  isClearable
                  id='CampaignId'
                  name='CampaignId'
                  placeholder='Kampanya seçiniz...'
                  options={
                    state.campaignList?.map(campaign => ({
                      label: `${campaign.Name} (${campaign.Id})`,
                      value: campaign.Id,
                    })) || []
                  }
                  value={state.selectedCampaign}
                  onChangeSingle={option => setState({ selectedCampaign: option })}
                />
              </div>

              <div className='form-group col-md-2'>
                <IPSelectBox
                  isClearable
                  id='Brand'
                  name='Brand'
                  placeholder='Marka seçiniz...'
                  options={state.brandList?.map(brand => ({ label: brand.Name, value: brand.Id })) || []}
                  value={state.brand as unknown as ISelectOption}
                  onChangeSingle={option => setState({ brand: option })}
                />
              </div>

              <div className='col-12 col-md-2 mb-3'>
                <IPButton text='Göster' onClick={getReport} />
              </div>

              <div className='form-group col-md-1'></div>
            </div>
          </form>

          {summary && (
            <div className='row mb-4'>
              <div className='col-md-3 mb-3'>
                <div className='card'>
                  <div className='card-body'>
                    <div><b>Kayıt Sayısı:</b> {summary.RecordCount}</div>
                    <div><b>Toplam Adet:</b> {summary.TotalQuantity}</div>
                  </div>
                </div>
              </div>

              <div className='col-md-3 mb-3'>
                <div className='card'>
                  <div className='card-body'>
                    <div><b>Kampanyalı Tutar:</b> {formatNumber(summary.TotalCampaignAmount)}</div>
                    <div><b>Eski Tutar:</b> {formatNumber(summary.TotalOldAmount)}</div>
                  </div>
                </div>
              </div>

              <div className='col-md-3 mb-3'>
                <div className='card'>
                  <div className='card-body'>
                    <div><b>Toplam İndirim:</b> {formatNumber(summary.TotalDiscountAmount)}</div>
                    <div><b>Ort. İndirim %:</b> {formatNumber(summary.AvgDiscountRate)}</div>
                  </div>
                </div>
              </div>

              <div className='col-md-3 mb-3'>
                <div className='card'>
                  <div className='card-body'>
                    <div><b>Farklı Ürün:</b> {summary.DistinctProductCount}</div>
                    <div><b>Farklı Bayi:</b> {summary.DistinctDealerCount}</div>
                    <div><b>Farklı Şirket:</b> {summary.DistinctCompanyCount}</div>
                    <div><b>Farklı Kampanya:</b> {summary.DistinctCampaignCount}</div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <b className='m-4' style={{ color: 'red' }}>Eski Tutar ve İndirim bilgileri yalnızca 2026 yılı ve sonrası için hesaplanabilmektedir.</b>
          <br></br>

          <div className='m-4'>
            <h5>Ham Data</h5>
            <Table columns={rawTableColumns} data={rawTableData} currentPage={0} />
          </div>

          <div className='m-4'>
            <h5>Şirket Bazlı Analiz</h5>
            <Table columns={analysisTableColumns} data={byCompanyTableData} currentPage={0} />
          </div>

          <div className='m-4'>
            <h5>Kampanya Bazlı Analiz</h5>
            <Table columns={analysisTableColumns} data={byCampaignTableData} currentPage={0} />
          </div>

          <div className='m-4'>
            <h5>Bayi Bazlı Analiz</h5>
            <Table columns={analysisTableColumns} data={byDealerTableData} currentPage={0} />
          </div>

          <div className='m-4'>
            <h5>Ürün Bazlı Analiz</h5>
            <Table columns={analysisTableColumns} data={byProductTableData} currentPage={0} />
          </div>

          <div className='m-4'>
            <h5>Marka Bazlı Analiz</h5>
            <Table columns={analysisTableColumns} data={byBrandTableData} currentPage={0} />
          </div>

          <div className='m-4'>
            <h5>Kategori Bazlı Analiz</h5>
            <Table columns={analysisTableColumns} data={byCategoryTableData} currentPage={0} />
          </div>

          <div className='m-4'>
            <h5>Kota Bazlı Analiz</h5>
            <Table columns={analysisTableColumns} data={byQuotaTableData} currentPage={0} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default componentWithContext(CampaignReport)